import type { Post } from '@pranala/shared'

// Import raw JSON content
import postsJson from './posts.json'

const allPosts = (postsJson as any[]).map(p => ({
  ...p,
  // Ensure dates are properly typed
  createdAt: p.createdAt ? new Date(p.createdAt) : new Date(),
  updatedAt: p.updatedAt ? new Date(p.updatedAt) : new Date(),
  publishedAt: p.publishedAt ? new Date(p.publishedAt) : null,
})) as Post[]

export function getAllPosts(options: {
  page?: number
  limit?: number
} = {}) {
  let result = [...allPosts].filter((p: Post) => p.status === 'published')
  
  // Sort by published date (newest first)
  result.sort((a: Post, b: Post) => {
    const dateA = a.publishedAt ? new Date(a.publishedAt).getTime() : new Date(a.createdAt).getTime()
    const dateB = b.publishedAt ? new Date(b.publishedAt).getTime() : new Date(b.createdAt).getTime()
    return dateB - dateA
  })
  
  const total = result.length
  const page = options.page || 1
  const limit = options.limit || 10
  const start = (page - 1) * limit
  
  return {
    posts: result.slice(start, start + limit),
    total,
    page,
    limit,
    totalPages: Math.ceil(total / limit),
  }
}

export function getPostBySlug(slug: string): Post | undefined {
  return allPosts.find((p: Post) => p.slug === slug && p.status === 'published')
}

export function getFeaturedPosts(limit: number = 3): Post[] {
  return allPosts
    .filter((p: Post) => p.status === 'published')
    .sort((a: Post, b: Post) => {
      const dateA = a.publishedAt ? new Date(a.publishedAt).getTime() : new Date(a.createdAt).getTime()
      const dateB = b.publishedAt ? new Date(b.publishedAt).getTime() : new Date(b.createdAt).getTime()
      return dateB - dateA
    })
    .slice(0, limit)
}
